import React from 'react'
import PropTypes from 'prop-types'
import { me } from '../../initial_state'
import SidebarSectionTitle from '../sidebar_section_title'
import SidebarSectionItem from '../sidebar_section_item'
import SidebarLayout from './sidebar_layout'

class SettingsSidebar extends React.PureComponent {

  render() {
    const { title } = this.props

    if (!me) return null

    return (
      <SidebarLayout
        showBackBtn
        title={title}
      >
        <SidebarSectionTitle>Menu</SidebarSectionTitle>
        <SidebarSectionItem title='Blocked users' to='/settings/blocks' />
        <SidebarSectionItem title='Muted users' to='/settings/mutes' />
        <SidebarSectionItem title='Preferences' href='/settings/preferences' />
      </SidebarLayout>
    )
  }

}

SettingsSidebar.propTypes = {
  title: PropTypes.string,
}

export default SettingsSidebar